import React, { useEffect } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { initGA } from '../../../utils/analytics';

const Page = ({ children, style = {} }) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      page: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        minHeight: '100%',
        width: '100%',
        height: '100%',
        position: 'relative',
        overflowX: 'hidden',
      },
    }),
  );
  const classes = useStyles();

  useEffect(() => {
    initGA();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.page} style={style}>
      {children}
    </div>
  );
};

export default Page;
